
import { Component, Vue, Prop } from 'vue-property-decorator'
import { MemberVO } from '@/views/biz/login/vo/MemberVO.vo'
import { CommonSearchIVO, CommonSearchOVO } from '@/views/biz/omr/vo/SearchVO.vo'
import { WrongAnswerNoteOVO } from '@/views/biz/note/vo/WrongAnswerNote.vo'
import axios from 'axios'

@Component
export default class WrongAnswerNotes extends Vue {
  @Prop() emExam !: string;
  @Prop() smNo !: string;

  WrongAnswerNotes: Array<WrongAnswerNoteOVO> = [] as Array<WrongAnswerNoteOVO>

  created(): void {
    const param = {} as CommonSearchIVO;
    param.emExam = this.emExam;
    param.smNo = this.smNo;

    // 오답노트 조회
    axios.get(`/wrong-answer-note/${this.emExam}/${this.smNo}`)
    .then(r => {
      this.WrongAnswerNotes = r.data;
    })
  }
  
}
